import { DeviceType } from '@repo/types';

export const useDeviceType = () => {
  if (typeof window === 'undefined') {
    return DeviceType.desktop;
  }

  if (window.innerWidth < 768) {
    return DeviceType.mobile;
  }

  if (window.innerWidth < 1440) {
    return DeviceType.tablet;
  }

  return DeviceType.desktop;
};
